import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
} from "react";

interface TopBarActionsValue {
  action: ReactNode | null;
  setAction: (action: ReactNode | null) => void;
}

const TopBarActionsContext = createContext<TopBarActionsValue>({
  action: null,
  setAction: () => {},
});

export const TopBarActionsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [action, setAction] = useState<ReactNode | null>(null);
  return (
    <TopBarActionsContext.Provider value={{ action, setAction }}>
      {children}
    </TopBarActionsContext.Provider>
  );
};

export function useTopBarActions(): TopBarActionsValue {
  return useContext(TopBarActionsContext);
}
